export const selectSalonServicesCategories = ($) => $?.salon?.services?.categories;
export const selectSalonServicesCategoriesAreFetched = ($) => $?.salon?.services?.areCategoriesFetched === true;
export const selectSalonServicesCategoriesIsFetching = ($) => $?.salon?.services?.isFetching === true;
export const selectSalonServicesCategoriesFetchError = ($) => $?.salon?.services?.errorMessage ?? '';
export const selectSalonStylistListRemovedAccess = ($) => $?.salon?.stylistList?.removedAccess ?? null;
export const selectSalonStylistListEmailsWithLogin = ($) => $?.salon?.stylistList?.emailsWithLogin ?? null;
